import { tickerItems } from '@/mocks/site';

export default function TickerStrip() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full overflow-hidden border-y border-primary-800 bg-primary-900">
      <div className="flex items-center">
        <span className="z-10 flex shrink-0 items-center gap-2 bg-accent-500 px-4 py-2.5 font-label text-xs text-primary-950">
          <i className="ri-radar-line"></i>
          赛事动态
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex w-max items-center">
            {loop.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex items-center gap-2 whitespace-nowrap px-6 py-2.5 font-label text-xs text-primary-100"
              >
                <i className="ri-price-tag-3-line text-accent-300"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}